/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Submenu object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 */
var Submenu = {
	init: function(){
		var hasSubmenu = ['articles', 'events', 'furni', 'extras', 'statistics', 'account', 'signin', 'signup', 'recovery', 'store', 'about', 'contact', 'blog', 'issues', 'staff', 'vacancies', 'rules', 'terms'];

		if($.inArray(App.get(1), hasSubmenu)!=-1){
			$('nav').append('<div id="submenu" class="'+App.get(1)+'"><div></div></div>');

			/* Nav */
			switch(App.get(1)){
				// Articles
				case 'articles':
					$('#submenu').children().append('<a '+(!App.get(2) ? 'class="active"' : null)+' href="/articles">'+Language.get('main.articles')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='search' ? 'class="active"' : null)+' href="/articles/search">'+Language.get('main.search')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='index' ? 'class="active"' : null)+' href="/articles/index">'+Language.get('main.index')+'</a>');
					if(App.isLogged())
						$('#submenu').children().append('<a '+(App.get(2)=='liked' ? 'class="active"' : null)+' href="/articles/liked">'+Language.get('main.favorites')+'</a>');
					break;
				// Events
				case 'events':
					$('#submenu').children().append('<a '+(!App.get(2) ? 'class="active"' : null)+' href="/events">'+Language.get('events')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='winners' ? 'class="active"' : null)+' href="/events/winners">'+Language.get('events.winners')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='help' ? 'class="active"' : null)+' href="/events/help">'+Language.get('main.help')+'</a>');
					break;
				// Furni
				case 'furni':
					$('#submenu').children().append('<a '+(!App.get(2) ? 'class="active"' : null)+' href="/furni">Furni</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='search' ? 'class="active"' : null)+' href="/furni/search">'+Language.get('main.search')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='search' ? 'class="active"' : null)+' href="/furni/recent">'+Language.get('furni.latest')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='search' ? 'class="active"' : null)+' href="/furni/edited">'+Language.get('furni.edited')+'</a>');
					if(App.isLogged())
						$('#submenu').children().append('<a '+(App.get(2)=='liked' ? 'class="active"' : null)+' href="/furni/liked">'+Language.get('main.favorites')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='help' ? 'class="active"' : null)+' href="/furni/help">'+Language.get('main.help')+'</a>');
					break;
				// Extras
				case 'extras':
					$('#submenu').children().append('<a '+((App.get(2)=='texts' || !App.get(2)) ? 'class="active"' : null)+' href="/extras/texts">'+Language.get('utilities.texts')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='characters' ? 'class="active"' : null)+' href="/extras/characters">'+Language.get('utilities.characters')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='info' ? 'class="active"' : null)+' href="/extras/info">'+Language.get('utilities.habbos')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='badges' ? 'class="active"' : null)+' href="/extras/badges">'+Language.get('utilities.badges')+'</a>');
					break;
				// Statistics
				case 'statistics':
					$.each(['statistics', 'community', 'messages', 'achievements'], function(index, value){
						$('#submenu').children().append('<a '+((App.get(2)==value || value=='statistics' && !App.get(2)) ? 'class="active"' : null)+' href="/statistics/'+value+'">'+Language.get('statistics.'+value)+'</a>');
					});
					break;
				// Account
				case 'account':
					$.each(['account', 'security', 'privacy', 'profile', 'incidences', 'support'], function(index, value){
						$('#submenu').children().append('<a '+((App.get(2)==value || value=='account' && !App.get(2)) ? 'class="active"' : null)+' href="/account/'+value+'">'+Language.get('main.'+value)+'</a>');
					});
					break;
				// Store
				case 'store':
					$('#submenu').children().append('<a '+(!App.get(2) ? 'class="active"' : null)+' href="/store">'+Language.get('store')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='afro' ? 'class="active"' : null)+' href="/store/afro">Afro</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='achievements' ? 'class="active"' : null)+' href="/store/achievements">'+Language.get('main.achievements')+'</a>');
					$('#submenu').children().append('<a '+(App.get(2)=='renamings' ? 'class="active"' : null)+' href="/store/renamings">'+Language.get('account.store_renamings')+'</a>');
					break;
				// Internal
				case 'about':
				case 'contact':
				case 'blog':
				case 'issues':
				case 'staff':
				case 'vacancies':
				case 'rules':
				case 'terms':
					$.each(['about', 'contact', 'blog', 'issues', 'staff', 'vacancies', 'rules', 'terms'], function(index, value){
						$('#submenu').children().append('<a '+(App.get(1)==value ? 'class="active"' : null)+' href="/'+value+'">'+Language.get('main.'+value)+'</a>');
					});
					break;
				// Accounts
				case 'signin':
				case 'signup':
				case 'recovery':
					$.each(['signin', 'signup', 'recovery'], function(index, value){
						$('#submenu').children().append('<a '+(App.get(1)==value ? 'class="active"' : null)+' href="/'+value+'">'+Language.get('main.'+value)+'</a>');
					});
					break;
			}
		}
	}
}